//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region IMR Imports

import { IIMRFullscreenContainer, IMRFullscreenContainerOptions } from '@imr/controls.angularjs/components/fullscreen-container'

//#endregion

import { IMRImageOptions, IIMRImage } from './image.interfaces'
import { IMRBaseControlController } from '../base'
import { OpFile } from '../../../models/core'
import { FileComponent, ConvertHelper, TypeHelper, LocalizationHelper } from '../../../helpers'


export class IMRImageController
    extends IMRBaseControlController<IIMRImage, IMRImageOptions>
    implements ng.IComponentController, IIMRImage {

    public get noDataText(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData) }

    public imgElementId: string
    public fullscreenContainerOptions: IMRFullscreenContainerOptions

    private fullscreenContainer: IIMRFullscreenContainer
    private file: OpFile
    private attachmentPreviewImageElement: JQuery
    private hasData: boolean
    private isFullscreen: boolean

    // #region Consts

    public get LOG_PREFIX(): string { return '[SIMAX.Common.Image]' }
    public get PreviewUnavailable(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PreviewUnavailable) }

    // #endregion

    // #region Members

    // #endregion

    // #region Ctor

    constructor(private $element: JQuery, private $timeout: any) {
        super()
        this.imgElementId = TypeHelper.guid()
    }

    // #endregion


    //#region Component

    protected initialize(options: IMRImageOptions): JQueryPromise<void> {
        return $.when(
            this.initializeFullscreenContainer()
        )
            .then(() => {
                if (options.image != null) {
                    this.setImage(options.image)
                }
            })
    }

    // #endregion

    // Fullscreen Container

    private initializeFullscreenContainer(): JQueryPromise<any> {
        this.fullscreenContainerOptions = {
            fullscreenContainerSelector: '.layout-container',

            onInitialized: (e) => this.fullscreenContainer = e.component
        }

        return TypeHelper.onInitializedAll(this.fullscreenContainerOptions)
    }

    private toggleFullscreen(): void {
        if (this.fullscreenContainer != null) {
            this.fullscreenContainer.toggleFullscreen()
            this.isFullscreen = this.fullscreenContainer.isFullscreen()
        }
    }

    // Fullscreen Container End

    private downloadImage(): void {
        if (this.file != null) {
            FileComponent.OpenFileSaver(this.file)
        }
    }

    // #region IIMRImage

    public setImage(imageFile: OpFile): void {
        this.file = imageFile
        this.attachmentPreviewImageElement = this.$element.find('#' + this.imgElementId)
        if (imageFile != null) {
            if (FileComponent.isImageFile(imageFile) === false) {
                this.attachmentPreviewImageElement.hide()
                this.hasData = false
            } else {
                this.hasData = true
                this.$timeout(() => {
                    let urlImage: string = ConvertHelper.fileToDataUrlImage(imageFile)

                    this.attachmentPreviewImageElement.attr('src', urlImage)
                    this.attachmentPreviewImageElement.show()

                })
            }
        } else {
            this.attachmentPreviewImageElement.hide()
            this.hasData = false
        }
    }

    // #endregion
}